import _kebabCase from 'lodash/kebabCase';

import useMediaConfig from './useMediaConfig';
import useAppView from "./useAppView";
import { getDeviceInfo } from '../../utils';

const fallbackConfig = {
    template: '{appView}_{context}_video-share',
    appViewTemplateMap: {
        web: 'web',
        'app/atbat': 'mlbapp-{platform}',
        'app/ballpark': 'ballparkapp-{platform}',
    },
};

const usePartnerId = () => {

    const {
        shareConfig: {
            partnerId: {
                template, appViewTemplateMap,
            } = fallbackConfig,
        } = {},
    } = useMediaConfig();
    const appView = useAppView();
    const context = typeof window !== 'undefined' ? _kebabCase(window?.adobeAnalytics?.pageName?.split(': ')?.pop() ?? 'Video Playback Page') : 'video-playback-page';
    const { platform = '' } = typeof window !== 'undefined' ? getDeviceInfo() || {} : {};
    return template.replace('{appView}', appViewTemplateMap[appView])
        .replace('{platform}', platform)
        .replace('{context}', context);

};

export default usePartnerId;
